import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 768px;
  height: 48px;

  position: relative;
  box-sizing: border-box;
  padding: 12px 40px;

  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme['white-primary']};
`;

export const BackIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  position: absolute;
  left: 20px;

  svg {
    width: 24px;
    height: 24px;
    cursor: pointer;

    path {
      fill: ${({ theme }) => theme['brown-primary']};
    }
  }
`;
